import Project from "../ui/project/Project";
import {useEffect, useState} from "react";

import IASA from '../../assets/Footer3.898c66605a981ee76ba2.png'
import IASA2 from '../../assets/iasaLogoType2.svg'
import Marvel from '../../assets/Marvel_Logo.svg.png'
import Nexter from '../../assets/Nexter.png'
import Natours from '../../assets/logo-green-2x.png'
import StandardOne from '../../assets/1630629824855.jpeg'
import {Carousel} from "flowbite-react";

import styles from "./Portfolio.module.css";


const projectsFirst = [
    {
        img: StandardOne,
        title: "Standard One",
        link:'https://www.standard-one.com/'
    },
    {
        img: IASA2,
        title: "KPI(Kyiv Polytechnic Institute) website for IASA",
        link: 'https://iasa-frontend.vercel.app/ua/home'
    },
    {
        img: Natours,
        title: "Booking website ",
        link: 'https://natours-zeta-jade.vercel.app/'
    },
]

const projectsSecond = [
    {
        img: IASA,
        title: "Hackathon IASA 2023",
        link: 'http://champ.iasa.kpi.ua/'
    },
    {
        img: Nexter,
        title: "Nexter app",
        link: 'https://nexter-bice-iota.vercel.app/'
    },
    {
        img: Marvel,
        title: 'Marvel Service (Personal usage)',
        link: 'https://marvel-service-azure.vercel.app/'
    },
]

const projects = [
        ...projectsFirst,
    ...projectsSecond
]

const Portfolio = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <section className={styles.portfolio} id='portfolio'>
            <div className={styles.width}>
                <div className={styles.titleWrapper}>
                    <h1 className={styles.title}>My Portfolio </h1>
                    <span className={styles.bgTitle}>Portfolio</span>
                </div>
                <div className='h-5/6 w-full'>
                    <Carousel slideInterval={7000} className={`z-10 ${styles.wrapperShown}`} leftControl={windowWidth < 1400 ? true : false}
                              rightControl={windowWidth < 1400 ? true : false}>
                                    <div className={`flex justify-center `}>
                                        <Project projects={projectsFirst}/>
                                    </div>
                                    <div className={`flex justify-center`}>
                                        <Project projects={projectsSecond}/>
                                    </div>
                    </Carousel>
                    <Carousel slideInterval={7000} className={`z-10 ${styles.mobileBlock}`} leftControl={windowWidth < 1400 ? true : false}
                              rightControl={windowWidth < 1400 ? true : false}>
                        {
                            projects.map((item)=>{
                                const {img,title,link} = item

                              return(
                                  <div className={`${styles.secondProjectWrapper} z-20`}>
                                      <div className='flex justify-center items-center h-1/2'>
                                          <img className={`${styles.icon}`} src={img} alt={title} />
                                      </div>
                                      <div className={styles.hiddenBlock}><a className={styles.link} href={link}>Go To</a></div>
                                      <div>
                                          <h1 className={styles.titleText}>{title}</h1>
                                      </div>
                                  </div>
                              )
                            })
                        }
                    </Carousel>
                </div>
            </div>
        </section>
    )
}


export default Portfolio